import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'
import { IServiceResponse } from '@/data/models/ServiceResponse'

export class SportApiService extends ApiService {
  static async getAll(): Promise<IServiceResponse<any>> {
    return this.axios.get('sports')
      .then((response: AxiosResponse) => response.data)
  }

  static async getAllRanks(): Promise<IServiceResponse<any>> {
    return this.axios.get('sport-ranks')
      .then((response: AxiosResponse) => response.data)
  }
}
